var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAll = function SvgAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.183 16.668a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm1 6v-4h28v4z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.183 40a1 1 0 0 1 1-1h28a1 1 0 1 1 0 2h-28a1 1 0 0 1-1-1M21.183 46a1 1 0 1 0 0 2h28a1 1 0 1 0 0-2zM20.183 33.875a1 1 0 0 1 1-1h28a1 1 0 1 1 0 2h-28a1 1 0 0 1-1-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M15.183 10a1 1 0 0 0-1 1v50a1 1 0 0 0 1 1h40a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1zm1 50V12h38v48z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M65.817 15a1 1 0 1 0-2 0v53h-41a1 1 0 1 0 0 2h43z"
  })));
};
export default SvgAll;